<template>
    <div class="wk-input-validate wk-input-box flex">
        <span class="input-left-label">{{label}}</span>
        <div class="flex-jf-end posi-relative">
            <input-base type="number" v-model="inputVal" :initVal="value" :placeholder="placeholderOver" maxlength="6" />
			<p class="txtTip txt-red posi-absolute">
				<template v-if="!isGetPCode">
					<span v-if="!isHuoQuCode" @click="$emit('getPhoneCode')">获取验证码</span> 
					<span v-else @click="$emit('getPhoneCode')">重新获取</span> 
				</template>
				<span v-else class="txt-gray"> 重新获取{{codeTime}}</span>
			</p>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
		props: ['label', 'placeholder','value'],
		mounted(){
			this.placeholderOver = this.label;
			if(this.placeholder){
				this.placeholderOver = this.this.placeholder;
			}
		},
		data(){
			return {
				isGetPCode:false, //-- 是否获得验证码
				isHuoQuCode:false, //-- 是否获过
				placeholderOver:'',
				codeTime:59,
				inputVal:''
			}
		},
		watch:{
            inputVal(newVal){
                if(newVal.length > 6){
                    this.inputVal = newVal.substr(0,6); 
                }
				this.$emit('input',this.inputVal);
            }
        },
		methods:{
			//设置是否获取了验证码
			setIsGetPCode(){
				this.isGetPCode = true;
			},
			//发送短信验证码
			sendPhoneCode(){ console.log(45)
				let that = this;
				//发送手机验证码
				that.$axios_post('other/sms/send').then((res)=>{
					// console.log('短信验证码',res)
					that.isGetPCode = true;
					that.isHuoQuCode = true;	
					if(res.code == '00000000'){
						that.isHuoQuCode = true;
						//去设置获取验证码的显示
						that.setIsHuoQuGuo();
					}
				});
			},
			//设置是否获取过
			setIsHuoQuGuo(){
				let that = this;
				that.isHuoQuCode = true;
				 
				//手机短信发送成功 ， 并启动定时器
				let timerTmp = setInterval(()=>{
				    if(that.codeTime > 1){
				        that.codeTime--;
				    }else if(that.codeTime == 1){
				        //清空计时器
				        clearInterval(timerTmp);
				        that.codeTime = 59; //恢复初始值
				        that.isGetPCode = false;
				    }
				},1000)
			},
			//获得当前输入的值
			getPhoneCode(){
				return this.value;
			}
		}
    }
</script>
<style lang="less" scoped>
    .wk-input-validate{
		margin-top:.9rem;
		>div{
			// 获取验证码
			>p.txtTip{
				width:5rem;
				top:.05rem;
				right:0;
				border-left:none;
				line-height:1.1rem;
				 
				cursor: pointer;
				span{
					display: inline-block;
					padding:.5rem 0;
					width:5rem;
					border-left:.05rem solid #d1d1d1;
					text-align: center;
				}
			}
		}    
    }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/inputValidate.vue